<template>
<div v-if="!isMobile">
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
    </v-app-bar>
  </nav>
 <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">
    <v-simple-table>
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="color:white;">
            Location(Recently)
          </th>
          <th class="text-left" style="color:white;">
            CO2 Level(Recently)
          </th>
          <th class="text-left" style="color:white;">
            Ambient Temperature(Recently)
          </th>
          <th class="text-left" style="color:white;">
            Ambient Temperature(Recently)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in airQuality"
          :key="item._id">
          <td>{{item.location[0].location}}</td>
          <td>{{item.co2}} ppm</td>
          <td>{{item.temp}} °C</td>
          <td>{{item.humid}} %RH</td>
        </tr>
      </tbody>
   
    </template>
  </v-simple-table>
   
  </v-col>
</v-row>
 </v-container>
</div>

<div v-else>
 
  <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
  </v-container>
  <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">
    <v-simple-table>
    <template v-slot:default>
      <thead>
       <tr>
           <th class="text-left" style="color:white;">
            Location
          </th>
          <th class="text-left" style="color:white;">
            CO2 Level(Recently)
          </th>
          <th class="text-left" style="color:white;">
            Ambient Temperature(Recently)
          </th>
          <th class="text-left" style="color:white;">
            Ambient Temperature(Recently) 
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in airQuality"
          :key="item._id">
          <td>{{item.location[0].location}}</td>
          <td>{{item.co2}} ppm</td>
          <td>{{item.temp}} °C</td>
          <td>{{item.humid}} %RH</td>
        </tr>
      </tbody>
   
    </template>
  </v-simple-table>
   
  </v-col>
</v-row>
 </v-container>
</div>

</template>


<script>
import axios from "axios";
import moment from 'moment';

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Air Quality',
          disabled: true,
          href: '',
        },
        {
          text: 'Overview',
          disabled: true,
          href: '',
        },
      ],
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    loading: true,
    isMobile: true,
    airQuality:[],
    tab: null,
  }),
  mounted() {
    this.loadsCO2();
    this.onResize();
    this.intervalFetchData();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
  intervalFetchData: function () {
    setInterval(() => {    
      this.loadsCo2(),this.loadsWeather()
       }, 300000); 
  },
  onResize() {
      this.isMobile = window.innerWidth < 700;
  },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsCO2: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/air-quality/" + "aq" + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.airQuality = res.data;
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
  },

 updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsCO2();
      this.loading = true;
    },

  updateBoard(){
      this.loadsCO2();
      this.loading = true;
    },

  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

}
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>